<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3"></div>
        <div
          class="col-24 col-md-11 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5"
        >
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('dashNdaTitle')"></h1>
            <h1 class="title">
              <span v-text="$ml.get('dashNdaSubTitle')" class="pb-2"></span>
            </h1>
            <!--  -->
            <div v-show="!program_list.length">
              <div class="card-body">
                <div class="align-self-center loading d-flex mt-1 w-100">
                  <div v-if="loading" class="c-loader m-1"></div>
                  <div v-else class="alert alert-warning p-2 d-flex flex-column text-center w-100 mt-3" >
                    <h6 class="my-1" v-text="$ml.get('youDontHaveAnyNDAs')">
                      Você ainda não possui um programa com contrato de
                      confidencialidade!
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div v-for="(item, index) in program_list" :key="index">
              <div class="card mb-3">
                <div class="card-body">
                  <div class="d-column flex-row">
                    <div
                      class="h-profile no h-profile-lg d-flex flex-column pb-3 align-items-center"
                    >
                      <div class="d-flex w-100">
                        <div
                          class="pl-2 d-flex flex-row w-100 justify-content-between align-center"
                        >
                          <b-row class="text-center" align-v="center">
                            <div>
                              <object
                                width="48"
                                height="48"
                                class="rounded-circle img-lg mr-3"
                                :data="item.avatar"
                                type="image/png"
                              >
                                <img
                                  width="48"
                                  height="48"
                                  class="rounded-circle img-lg mr-3"
                                  src="../../../assets/images/default.png"
                                  alt="Avatar"
                                />
                              </object>
                            </div>
                            <div>
                              <h3>
                                <a class="link-block" ><strong v-text="item.name"></strong ></a>
                              </h3>
                            </div>
                          </b-row>
                          <b-row
                            align-v="center"
                            class="actions mt-2 d-flex flex-row"
                            v-show="item.type == 'private'"
                          >
                            <span v-if="item.vpn_required" class="ico ico-vpn mr-1">
                              <img src="../../../assets/images/vpn.png" />
                            </span>
 
                            <span class="ico ico-locked mr-1">
                              <img src="../../../assets/icons/lock.svg" class="ico-13" />
                            </span>
                            <span
                              class="ico ico-nda mr-1"
                              v-show="item.program_nda"
                            >
                              <img src="../../../assets/icons/security-shield.svg" />
                            </span>
                            <span class="ico ico-managed" v-show="item.managed">
                              <img src="../../../assets/images/bughunt.svg" />
                            </span>
                          </b-row>
                        </div>
                      </div>
                      <div
                        v-if="item.program_nda"
                        class="p-2 d-flex flex-column text-center w-100 mt-3"
                      >
                        <label
                          class="alert alert-success"
                          v-text="$ml.get('programWithNda')"
                        >
                          Este programa possui um NDA vinculado!
                        </label>
                        <!-- <div>
                          <router-link
                            v-text="$ml.get('navEditNda')"
                            :to="'/program/set-nda?' + item._id"
                            class="btn btn-top mt-3"
                          >
                          </router-link>
                        </div> -->
                      </div>
                      <div
                        v-else
                        class="p-2 d-flex flex-column text-center w-100 mt-3"
                      >
                        <label
                          class="alert alert-warning"
                          v-text="$ml.get('programWithoutNda')"
                        >
                          Este programa ainda não possui um NDA vinculado!
                        </label>
                        <!-- <div>
                          <router-link
                            v-text="$ml.get('navCreateNda')"
                            :to="'/program/set-nda?' + item._id"
                            class="btn btn-top mt-3"
                          >
                          </router-link>
                        </div> -->
                      </div>
                      <div
                        class="card-chart-body w-100"
                        v-show="item.program_nda"
                      >
                        <div class="row">
                          <div class="col-12 border-r-d pl-3 mb-2">
                            <b-row
                              align-v="center"
                              class="actions mt-2 d-flex flex-row"
                            >
                              <span
                                class="pb-1"
                                v-text="$ml.get('agreementSpecialists')"
                                >Especialistas em acordo</span
                              >
                              <b-button
                                v-if="item.acceptedByAmount > 0"
                                class="nda-icon-button bg-light ml-3 float-right"
                                v-b-toggle="`collapse-${item._id}`"
                                @click="loadAcceptedNdaList(item._id)"
                              >
                                <span class="ico-btn">
                                  <img
                                    class="img-ico-btn ml-2"
                                    src="../../../assets/icons/search_s.svg"
                                  />
                                </span>
                              </b-button>
                            </b-row>
                            <h6><a v-text="item.acceptedByAmount"></a></h6>
                          </div>

                          <div
                            class="col-12  pl-3 mb-2"
                            v-show="item.program_nda"
                            align-v="center"
                          >
                            <b-row
                              align-v="center"
                              class="actions mt-2 d-flex flex-row"
                            >
                              <span
                                class="pb-1"
                                v-text="$ml.get('waitingConfirmation')"
                                >Aguardando confirmação</span
                              >
                            </b-row>
                            <h6><a v-text="item.pendingInvitations"></a></h6>
                          </div>
                        </div>
                      </div>
                      <div>
                        <p class="d-flex align-items-center">
                          <span
                            class="align-self-center mt-2"
                            v-text="
                              $ml
                                .with(
                                  $utils.formatData(
                                    item.createdAt,
                                    $ml.get('ln')
                                  )
                                )
                                .get('publishedDaysAgo')
                            "
                            >Publicado há
                          </span>
                        </p>
                      </div>
                      <div class="mt-2 w-100">
                        <!-- Elements to collapse -->
                        <b-collapse :id="`collapse-${item._id}`">
                          <b-row
                            class="w-100 card mt-1"
                            v-for="(item, index) in accepted_nda_list[item._id]"
                            :key="index"
                          >
                            <div class="card-body">
                              <div class="d-column flex-row">
                                <div
                                  class="h-profile h-profile-lg d-flex flex-column pb-3 align-items-center no"
                                >
                                  <div class="d-flex w-100">
                                    <div
                                      class="pl-2 d-flex flex-row w-100 justify-content-between align-center"
                                    >
                                      <b-row
                                        class="text-center"
                                        align-v="center"
                                      >
                                        <div style="width: 62px">
                                          <object width="48" height="48" class="rounded-circle img-lg mr-3" :data="item.avatar" type="image/png" >
                                            <img width="48" height="48" class="rounded-circle img-lg mr-3" src="../../../assets/images/default.png" alt="Avatar" />
                                          </object>
                                        </div>
                                        <div> 
                                          <label
                                            class="link-block"
                                            v-text=" item.username + ' assinou o documento em ' + $utils.formatDataLong( item.program_nda_createdAt, $ml.get('ln') ) + '.' "
                                          ></label>
                                        </div>
                                      </b-row>
                                      <b-row
                                        align-v="center"
                                        class="actions mt-2 d-flex flex-row"
                                      >
                                        <b-button
                                          class="nda-icon-button mr-2 bg-light"
                                          @click="loadNda(item, 'showModal')"
                                        >
                                          <span class="ico-btn">
                                            <img
                                              class="img-ico-btn ml-2"
                                              src="../../../assets/icons/eye.svg"
                                            />
                                          </span>
                                        </b-button>
                                        <b-button
                                          class="nda-icon-button bg-light"
                                          @click="loadNda(item, 'downloadPdf')"
                                        >
                                          <span class="ico-btn">
                                            <img
                                              class="img-ico-btn ml-2"
                                              src="../../../assets/icons/download.svg"
                                            />
                                          </span>
                                        </b-button>
                                      </b-row>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-row>
                        </b-collapse>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-24 col-md-5 pr-md-3 py-md-3 px-3 px-md-0">
          <section>
            <div class="card mb-3">
              <div class="card-header border-0 pb-0">
                <div class="d-flex flex-row">
                  <span v-text="$ml.get('whatIsAnNda')"
                    >O que é um NDA e como ele pode ajudar a sua empresa?</span
                  >
                </div>
                <img
                  class="img-support"
                  src="../../../assets/images/contract.png"
                />
              </div>
              <div class="card-body footer-helper pb-2 d-flex flex-column">
                <p v-text="$ml.get('whatIsAnNda2')">
                  NDA é uma sigla em inglês para Non-Disclosure-Agreements, ou
                  simplesmente acordo de sigilo de informações.
                </p>
                <p v-text="$ml.get('whatIsAnNda3')">
                  Ele tem a intenção de proteger segredos industriais,
                  comerciais, ou ainda qualquer informação que não pode ser
                  divulgada e deve manter-se em sigilo entre aqueles que têm
                  acesso a ela.
                </p>
              </div>
            </div>
          </section>
        </div>

        <b-modal
          id="modal-nda"
          class="my-modal"
          data-bs-keyboard="false"
          hide-header
          hide-footer
          size="xl"
        >
          <b-container
            fluid="xl"
            style="max-height: 80vh !important; overflow-y: auto !important;"
          >
            <div class="col modal-body">
              <div v-show="htmlText" v-html="htmlText" class="m-4"></div>
            </div>
          </b-container>
        </b-modal>
      </section>
    </main>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import ProgramService from "../../../services/program.service";

export default {
  name: "Nda",

  data() {
    return {
      program_list: [],
      loading: false,
      accepted_nda_list: [],
      selectedProgram: "",
      htmlText: "",
      nda: "",
      name: "",
      company_name: "",
    };
  },
  mounted() {
    this.loadNdaList();
  },
  methods: {
    async loadNdaList() {
      this.loading = true;
      ProgramService.getNdaList().then(
        (response) => {
          if (response.data) {
            this.program_list = response.data;
 
            this.program_list.forEach((element) => {
              element.accepted = element.acceptedby?.length ?? 0;
              element.pending = 0;
            });
          }
          this.loading = false;
        },
        () => {
          this.loadingBtn = false;
          Swal.fire({
            icon: "info",
            title: self.$ml.get("unableToCompleteThisRequest"),
            showConfirmButton: false,
            timer: 3000,
          });
          this.loading = false;
        }
      );
    },
    async loadAcceptedNdaList(programId) {
      this.selectedProgram = programId;
      this.loading = true;
      ProgramService.getAcceptedNdaList(programId).then(
        (response) => {
          if (response.data) {
            this.accepted_nda_list[programId] = response.data;
          }
          this.loading = false;
        },
        () => {
          this.loadingBtn = false;
          Swal.fire({
            icon: "info",
            title: self.$ml.get("unableToCompleteThisRequest"),
            showConfirmButton: false,
            timer: 3000,
          });
          this.loading = false;
        }
      );
    },
    async loadNda(item, param) { 
      this.htmlText = "";
      this.nda = item.program_nda_description;
      this.name = item.person_name;
      this.company_name = item.company_name;
      this.htmlText = this.$utils.convertMarkedOld(
        this.nda,
        [],
        this.company_name,
        this.name
      );
      this.htmlText += `<br><p><b>${item.person_name}</b> assinou o documento em ${this.$utils.formatDataLong( item.program_nda_createdAt)}.</p>
                       <p style="word-break: break-all;"><b>MetaMap Token:</b> ${item.mati_token}</p>` 

      if (param == "downloadPdf") {
        this.printDiv();
      } else if (param == "showModal") {
        this.$bvModal.show("modal-nda");
      }
    },
    printDiv() {
      let mywindow = window.open(
        "",
        "PRINT",
        "height=650,width=900,top=100,left=150"
      );

      mywindow.document.write("</head><body >");
      mywindow.document.write(this.htmlText);
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      mywindow.close();

      return true;
    },
  },
};
</script>

<style scoped>
li {
  padding-bottom: 1rem;
}
.primary-text {
  color: #730ba9 !important;
}
.nda-icon-button {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center !important;
  align-content: center !important;
  align-items: center !important;
  border-radius: 5px;
}
.ico-btn {
  width: auto;
  height: auto;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  border-radius: 5px;
}
.img-ico-btn {
  width: 30px;
  height: 20px;
  align-self: center;
}
</style>
